import React, { MouseEventHandler } from 'react';
import { classes } from '@bloomberg/media-ui-core';
import { PlusStroke } from '@bloomberg/media-ui-icons';

import styles from './DropdownOption.module.css';

export type DropdownOptionProps = {
  value: string;
  displayValue?: string;
  subText?: string;
  variant?: 'default' | 'markets';
  size?: 'default' | 'small' | 'extraSmall';
  isSelected?: boolean;
  isHighlighted?: boolean;
  className?: string;
  'aria-selected'?: boolean;
  onClick?: MouseEventHandler<Element> | (() => void);
  id?: string;
  role?: string;
  url?: string;
  showPlusIcon?: boolean;
};

export const DropdownOption = React.forwardRef<
  HTMLLIElement,
  DropdownOptionProps
>(function DropdownOption(
  {
    variant = 'default',
    size = 'default',
    isSelected,
    isHighlighted,
    className,
    id,
    'aria-selected': ariaSelected,
    role,
    displayValue,
    value,
    subText,
    onClick,
    url,
    showPlusIcon,
  },
  ref
) {
  const dropdownContent = (
    <>
      <p className={styles.title}>{displayValue || value}</p>
      {subText && variant === 'markets' && (
        <p className={styles.subtitle}>{subText}</p>
      )}
    </>
  );

  return (
    <li
      ref={ref}
      aria-selected={ariaSelected}
      className={classes([
        styles.dropdownOption,
        styles[variant],
        className,
        {
          [styles.small]: size === 'small' || size === 'extraSmall',
          [styles['item-selected']]: isSelected,
          [styles['item-highlighted']]: isHighlighted,
        },
      ])}
      id={id}
      role={role}
      onClick={onClick}
    >
      <div>{url ? <a href={url}>{dropdownContent}</a> : dropdownContent}</div>
      {showPlusIcon && (
        <div className={styles.icon}>
          <PlusStroke />
        </div>
      )}
    </li>
  );
});
